import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalService } from 'src/app/core/services/modal.service';
import { TrainingRequestComponent } from '../training-request/training-request.component';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
})
export class SupportComponent implements OnInit {

  constructor(private router: Router,
    private modalService: ModalService) { }

  ngOnInit() { }

  navigate(type) {
    let url = this.router.url + "/" + type;
    this.router.navigate([url]);
  }


  addTraining() {
    this.modalService.presentModal({
      component: TrainingRequestComponent,
      componentProps: {},
      options: ModalService.defaultOptionsTransparent,
    }).then(e => {
      e.modalObj.onDidDismiss().then(modal => {
        if (modal.role == "success") {
          let url = this.router.url + "/ask-expert";
          this.router.navigate([url]);
        }
      });
    });
  }

}
